var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLossreason(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6243",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6247"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path6255"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6275"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path6273"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g6249",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6253",
    clipPath: "url(#clipPath6257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 482.28,39.91 h -64.65 v 111.12 h 64.65 z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6259"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 320.65,201.539 H 385.3 V 39.913 h -64.65 z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6261"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6263",
    transform: "translate(288.3301,145.9805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -106.07 H -64.66 V 106.069 H 0 V 35",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6265"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 126.699,302.556 h 64.65 V 39.913 h -64.65 z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6267"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6271",
    clipPath: "url(#clipPath6275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6277",
    transform: "translate(94.3701,255.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -215.8 H -64.65 V 97.35 L 0,97.35 V 35",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6279"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 7.5,7.588 h 497 V 39.913 H 7.5 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6281"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6283",
    transform: "translate(307.02,379.4639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 102.93,-56.641 -6.57,22.68 c -2.49,8.57 2.44,17.53 11.02,20.021 8.57,2.49 17.53,-2.451 20.02,-11.021 l 17.45,-60.149 c 2.49,-8.571 -2.45,-17.54 -11.02,-20.021 L 73.68,-122.58 c -8.57,-2.49 -17.54,2.439 -20.03,11.019 -2.48,8.571 2.45,17.54 11.02,20.021 l 22.68,6.579 -326.51,179.671 c -7.82,4.31 -10.67,14.13 -6.37,21.949 2.16,3.91 5.69,6.58 9.66,7.731 3.97,1.16 8.39,0.79 12.3,-1.361 L -30.66,16.869",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path6285"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossreason);
export default __webpack_public_path__ + "static/media/loss reason.bda3f50ec9f2c87b9667fc48ef3ca146.svg";
export { ForwardRef as ReactComponent };